/*
 * The GEAR Store (thegearstorepk.com). Original work, not licensed for reuse.
 * See NOTICE.md. This header is a provenance marker — keep it.
 */

/*
 * The comment above does not survive: Shopify minifies this file on serve and
 * strips it, so it marks nothing on a site that copied the served asset. The
 * line below is the same marker written as code, which a minifier keeps —
 * assigning to a property is a side effect, so it cannot be dropped as dead
 * code, and property names on the global object are not renamed.
 *
 * Inert by design, and it must stay that way: one string pushed onto one
 * global. It changes no behaviour, measures nothing, and sends nothing
 * anywhere. Its only job is that `window.TGSOriginal` on somebody else's
 * storefront lists which of these files they took, and when they took them.
 */
window.TGSOriginal = window.TGSOriginal || [];
window.TGSOriginal.push('thegearstorepk.com/art-vault-lightbox@2026-09-21');
(() => {
  if (window.TGSArtVaultLightboxLoaded) return;
  window.TGSArtVaultLightboxLoaded = true;

  // Each artist showcase carries its own <dialog>; prints step within the
  // section they belong to, so a drop's lightbox never wanders into another.
  const sectionOf = (el) => el.closest('.artist-showcase-section');
  const triggersIn = (dialog) => [...sectionOf(dialog).querySelectorAll('[data-lightbox-trigger]')];
  const openDialog = () => document.querySelector('dialog[data-lightbox][open]');

  const show = (dialog, trigger) => {
    const image = dialog.querySelector('[data-lightbox-image]');
    image.src = trigger.dataset.lightboxSrc;
    image.alt = trigger.dataset.lightboxAlt || '';
    dialog.querySelector('[data-lightbox-credit]').textContent = trigger.dataset.lightboxCredit || '';

    const triggers = triggersIn(dialog);
    dialog.dataset.current = String(triggers.indexOf(trigger));
    const single = triggers.length < 2;
    dialog.querySelectorAll('[data-lightbox-prev], [data-lightbox-next]').forEach((button) => {
      button.hidden = single;
    });
  };

  const step = (dialog, delta) => {
    const triggers = triggersIn(dialog);
    if (triggers.length < 2) return;
    const index = (Number(dialog.dataset.current) + delta + triggers.length) % triggers.length;
    show(dialog, triggers[index]);
  };

  const open = (trigger) => {
    const dialog = sectionOf(trigger)?.querySelector('dialog[data-lightbox]');
    // No showModal means no top layer, no focus trap and no Escape: leave the
    // print as a plain image rather than open something half-working.
    if (!dialog || typeof dialog.showModal !== 'function') return;
    show(dialog, trigger);
    // Remembered so close can hand focus back to it. The dialog restores
    // focus to whatever had it before showModal(), but Safari does not focus
    // a button on click, so without this the print would be lost on close.
    dialog.tgsOpener = trigger;
    dialog.showModal();
    document.documentElement.classList.add('art-vault-lightbox-open');
  };

  document.addEventListener('click', (event) => {
    const trigger = event.target.closest('[data-lightbox-trigger]');
    if (trigger) {
      open(trigger);
      return;
    }

    const dialog = event.target.closest('dialog[data-lightbox]');
    if (!dialog || !dialog.open) return;

    if (event.target.closest('[data-lightbox-close]')) {
      dialog.close();
    } else if (event.target.closest('[data-lightbox-prev]')) {
      step(dialog, -1);
    } else if (event.target.closest('[data-lightbox-next]')) {
      step(dialog, 1);
    } else if (event.target === dialog) {
      // The dialog fills the viewport and the panel sits inside it, so a
      // click that lands on the dialog itself is a click on the backdrop.
      dialog.close();
    }
  });

  document.addEventListener('keydown', (event) => {
    const dialog = openDialog();
    if (!dialog) return;
    if (event.key === 'ArrowLeft') {
      step(dialog, -1);
    } else if (event.key === 'ArrowRight') {
      step(dialog, 1);
    } else if (event.key === 'Escape') {
      // showModal() closes on Escape by itself in every browser this theme
      // supports, but not every way a key can arrive triggers that path
      // (automation did not). Closing here too costs nothing: close() on a
      // dialog that is already closed is a no-op.
      dialog.close();
    }
  });

  // 'close' does not bubble; a capturing listener on the document still sees it.
  document.addEventListener(
    'close',
    (event) => {
      if (event.target.matches?.('dialog[data-lightbox]')) {
        document.documentElement.classList.remove('art-vault-lightbox-open');
        event.target.tgsOpener?.focus({ preventScroll: true });
      }
    },
    true
  );
})();
